// Ported verbatim from the LeadMailer Design System (components/overlays/Tabs.jsx).
import React from 'react'

export type Tab = string | { value: string; label: React.ReactNode }

export interface TabsProps {
  tabs?: Tab[]
  value?: string
  onChange?: (value: string) => void
  style?: React.CSSProperties
}

export function Tabs({ tabs = [], value, onChange, style }: TabsProps) {
  return (
    <div
      role="tablist"
      style={{
        display: 'flex',
        gap: 4,
        padding: 3,
        background: 'var(--surface-sunken)',
        borderRadius: 'var(--radius-md)',
        width: 'fit-content',
        maxWidth: '100%',
        overflowX: 'auto',
        ...style,
      }}
    >
      {tabs.map((t) => {
        const id = typeof t === 'string' ? t : t.value
        const label = typeof t === 'string' ? t : t.label
        const active = id === value
        return (
          <button
            className="tap"
            key={id}
            role="tab"
            aria-selected={active}
            onClick={() => onChange && onChange(id)}
            style={{
              border: 'none',
              cursor: 'pointer',
              padding: '6px 14px',
              minHeight: 30,
              borderRadius: 'calc(var(--radius-md) - 3px)',
              fontFamily: 'var(--font-sans)',
              fontSize: 'var(--text-sm)',
              fontWeight: 'var(--weight-medium)' as React.CSSProperties['fontWeight'],
              whiteSpace: 'nowrap',
              color: active ? 'var(--text-primary)' : 'var(--text-muted)',
              background: active ? 'var(--surface-card)' : 'transparent',
              boxShadow: active ? 'var(--shadow-xs)' : 'none',
              transition: 'color var(--dur-fast) var(--ease-out)',
            }}
          >
            {label}
          </button>
        )
      })}
    </div>
  )
}
